import { db } from './db';

export const tablesToKeep = new Set(['unsyncedSales', 'printers']);

export async function clearExistingData() {
    const clearPromises = db.tables.map((table) => {
        const tableName = table.name;
        if (tablesToKeep.has(tableName)) {
            return Promise.resolve();
        }

        return table.clear();
    });

    return await Promise.all(clearPromises);
}

export async function requestPersistentStorage(): Promise<boolean> {
    try {
        if (!('storage' in navigator) || !('persist' in navigator.storage)) {
            return false;
        }

        return await navigator.storage.persist();
    } catch (error) {
        console.error('Failed to request persistent storage:', error);
        return false;
    }
}
